import { Component } from 'react';

class MapsLengthMarker extends Component {

    constructor(props) {
        super(props);
        this.marker = null;
        this.redraw = this.redraw.bind(this);
    }

    componentWillUnmount() {
        if ( this.marker !== null ) {
            this.marker.setMap(null);
        }
    }

    redraw() {
        const { coordsTuple, mapType } = this.props;
        const { coord1, coord2 } = coordsTuple;
        if ( window.mapRef === undefined || coord1 === undefined || coord2 === undefined ) return;

        const _coord1 = new window.google.maps.LatLng({lat: coord1.lat, lng: coord1.lng});
        const _coord2 = new window.google.maps.LatLng({lat: coord2.lat, lng: coord2.lng})
        var bound = new window.google.maps.LatLngBounds();
        bound.extend(_coord1);
        bound.extend(_coord2);
        const midCoord = bound.getCenter();

        const length = window.google.maps.geometry.spherical.computeDistanceBetween(_coord1, _coord2);

        var textColor = '#F0F0F0';
        if ( mapType === 'roadmap' ) {
            textColor = '#1B1B1B';
        }

        if ( this.marker === null ) {
            this.marker = new window.google.maps.Marker({
                position: midCoord,
                icon:{
                    path: window.google.maps.SymbolPath.CIRCLE,
                    backgroudColor:'red'
                },
                label: {
                    color: textColor,
                    fillColor:'#1BB1B1B',
                    fontFamily: '"Prompt", sans-serif',
                    fontSize: '14px',
                    fontWeight: '600',
                    text: length.toFixed(2)+' ม.',
                },
                map: window.mapRef
            });
        }
        else {
            this.marker.setPosition(midCoord);
            this.marker.setLabel({
                color: textColor,
                fontFamily: '"Prompt", sans-serif',
                fontSize: '14px',
                fontWeight: '600',
                text: length.toFixed(2)+' ม.',
            });
        }
    }

    render() {
        this.redraw();
        return null;
    }

}

export default MapsLengthMarker;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsLengthMarker.js